module.exports = __webpack_public_path__ + "static/media/7.20.381042a2.png";